<template>
    <v-card class="mb-5 pa-2">
        <card-header
            :title="
                $t('plans.form.texts.title', {
                    'title-prefix': titlePrefix,
                })
            "
        />

        <template v-if="!plan">
            <v-container fluid class="fill-height">
                <v-row justify="center" align="center">
                    <v-col class="text-center" xs="12" md="12">
                        <v-progress-circular
                            :size="50"
                            color="primary"
                            indeterminate
                        ></v-progress-circular>
                    </v-col>

                    <v-col class="text-center">
                        {{ $t('roles.form.texts.loading') }}
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-else>
            <v-form ref="form" @submit.prevent="save">
                <v-card-text>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="4">
                            <label class="subtitle-2">
                                <v-icon left>mdi-file-lock</v-icon>
                                {{ $t('plans.form.labels.partner') }}
                            </label>
                            <v-radio-group
                                v-model="model.partner"
                                row
                                :error-messages="PartnerErrors"
                                @change="$v.model.partner.$touch()"
                            >
                                <v-card outlined class="mr-2 pa-5">
                                    <v-radio
                                        :label="$t('form.status.active')"
                                        color="success"
                                        :value="true"
                                    ></v-radio>
                                </v-card>
                                <v-card outlined class="mr-2 pa-5">
                                    <v-radio
                                        :label="$t('form.status.disabled')"
                                        color="red"
                                        :value="false"
                                    ></v-radio>
                                </v-card>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4">
                            <label class="subtitle-2">
                                <v-icon left>mdi-file-lock</v-icon>
                                {{ $t('plans.form.labels.whitelabel') }}
                            </label>
                            <v-radio-group
                                v-model="model.whitelabel"
                                row
                                :error-messages="WhitelabelErrors"
                                @change="$v.model.whitelabel.$touch()"
                            >
                                <v-card outlined class="mr-2 pa-5">
                                    <v-radio
                                        :label="$t('form.status.active')"
                                        color="success"
                                        :value="true"
                                    ></v-radio>
                                </v-card>
                                <v-card outlined class="mr-2 pa-5">
                                    <v-radio
                                        :label="$t('form.status.disabled')"
                                        color="red"
                                        :value="false"
                                    ></v-radio>
                                </v-card>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card-text>

                <form-actions :loadingSave="loading" />
            </v-form>
        </template>
    </v-card>
</template>

<script>
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'
import BaseModel from '@/models/BaseModel'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    props: {
        plan: {
            type: Object,
            required: true,
            validator: model => {
                return model instanceof BaseModel
            },
        },
        isEdit: {
            type: Boolean,
            default: () => {
                return true
            },
        },
        titlePrefix: String,
    },

    data: () => {
        return {
            loading: false,
        }
    },

    components: {
        'card-header': CardHeader,
        'form-actions': FormActions,
    },

    mixins: [validationMixin],

    validations: {
        model: {
            partner: { required },
            whitelabel: { required },
        },
    },

    methods: {
        async save() {
            this.loading = true

            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('form.validation-error'),
                )

                this.loading = false
                return
            }

            let clone = this.model.clone()

            let res = null

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$emit('saved')

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('plans.form.feedback.success', { name: clone.name }),
            )
        },

        clear() {
            this.$refs.form.reset()
        },
    },

    computed: {
        model() {
            return this.plan
        },

        PartnerErrors() {
            const errors = []
            if (!this.$v.model.partner.$dirty) return errors

            !this.$v.model.partner.required &&
                errors.push(this.$t('plans.form.errors.partner.required'))

            return errors
        },
        WhitelabelErrors() {
            const errors = []
            if (!this.$v.model.whitelabel.$dirty) return errors

            !this.$v.model.whitelabel.required &&
                errors.push(this.$t('plans.form.errors.whitelabel.required'))

            return errors
        },
    },
}
</script>
